import React from "react";

const BlogHeader = () => (
  <section className="w-full bg-light-4 py-12 px-6 text-center">
    <h1 className="text-title font-bold text-dark-1 mb-4">📰 Blog NextMaker</h1>
    <p className="text-normal text-light-1 max-w-2xl mx-auto">
      Bienvenue sur le <strong>Blog GoNextMaker</strong>, l’espace où nous partageons nos découvertes,
      nos histoires et nos inspirations autour de l’apprentissage créatif, du numérique et de la fabrication.
    </p>
    <p className="text-dark-3 mt-4 max-w-xl mx-auto">
      Ici, chaque article est une porte ouverte sur le futur de l’éducation et du <em>learning by making</em>.
    </p>
  </section>
);

export default BlogHeader;
